const skillsData = 
{
    frameworks: 
    [
        "React.js",
        "React Testing Library",
        "Jest",
        "PostgreSQL",
        "MongoDB",
        "Node",
        "Git",
    ],
    codingLanguages: 
    [
        "TypeScript",
        "C++",
        "Python",
    ],
    languages: 
    [
        "English",
        "Mandarin Chinese"
    ],
}

export default skillsData